
  import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component
  export default class GAlertConfirmation extends Vue {
  @Prop({ type: String, default: 'secondary' }) color!: string;
  @Prop({ type: String, default: 'white' }) textColor!: string;
  @Prop({ type: String, default: '400' }) width!: string;
  @Prop({ type: String, default: 'Confirmación' }) title!: string;
  @Prop({ type: String, default: '¿Está seguro que desea realizar esta acción?' }) subtitle!: string;
  @Prop({ type: Boolean, default: false }) open!: boolean;
  @Prop({ type: String, default: 'Aceptar' }) buttonTitle!: string;
  @Prop({ type: String, default: 'confirmar' }) expectedWord!: string;
  @Prop({ type: String, default: 'mdi-alert' }) icon!: string;
  @Prop({ type: String, default: 'warning' }) iconColor!: string;

  // Data
  confirmationText = '';

  // Computed
  get isDisabled (): boolean {
    return this.confirmationText !== this.expectedWord
  }

  // Watchers
  @Watch('open')
  onOpenChange (val: boolean): void {
    if (!val) {
      this.confirmationText = ''
    }
  }
  }
